module.exports = __webpack_public_path__ + "img/yzm.99006d0a.svg";